import React, { useState } from "react";
import { Box, Grid, SimpleGrid, Text } from "@chakra-ui/react";
import { format,  } from "date-fns";

import { Card } from "components";
import { Invoice, InvoiceStatus } from "types/invoice";
import { padNum, prettyMoney } from "utils";
import InvoiceActions from "./InvoiceActions";
import StatusTag from "./StatusTag";
import { useUser } from "context/user";
import { UserRole } from "types";
import { updateInvoice } from "api/webservice/invoice";
import {TzInvariantDate} from "utils/date";

interface Props {
  invoice: Invoice;
}

const InvoiceRow: React.FC<Props> = ({ invoice: initialInvoice }: Props) => {
  const [invoice, setInvoice] = useState(initialInvoice);
  const { user } = useUser()!;
  const { amount, start_date, due, invoice_num, organization } = invoice;
  const handleChangeStatus = (newStatus: InvoiceStatus): void => {
    updateInvoice({
      id: invoice.id,
      status: newStatus
    }).then(newInvoice => setInvoice(newInvoice));
  };
  return (
    <Card>
      <Grid gap={5} templateColumns="1fr fit-content(100%)">
        <SimpleGrid columns={2} gap={3}>
          <Text fontSize="2xl">{`${organization.name}_${padNum(
            invoice_num,
            5
)} (${format(TzInvariantDate(start_date), "LLL yyyy")})`}</Text>
      <Text>{`Pay By: ${format(TzInvariantDate(due), "PP")}`}</Text>
          <Text fontSize="lg">{prettyMoney(amount)}</Text>
          <StatusTag
            status={invoice.status}
            editable={user.privs >= UserRole.Admin}
            callback={handleChangeStatus}
          />
        </SimpleGrid>
        <InvoiceActions invoice={invoice} />
      </Grid>
    </Card>
  );
};

export default InvoiceRow;
